import { Position } from '@oai-frontend-monorepo/types';

export const getOptionSymbolsFromPosition = (
  position?: Position,
  optionsOnly?: boolean
) => {
  if (!position) {
    return [];
  }

  const symbols = position.legPositions.map((l) => l.symbol);

  if (!symbols.length) {
    return [];
  }

  if (optionsOnly) {
    return symbols.filter((s) => s.length > 6);
  }

  // assume any symbol over the length of 6 is an option symbol
  return symbols;
};

export const getOptionSymbolsFromPositions = (positions?: Position[]) => {
  if (!positions) {
    return [];
  }

  return positions.reduce((acc, p) => {
    return [...acc, ...getOptionSymbolsFromPosition(p)];
  }, [] as string[]);
};
